import { TodoDescriptor } from '../../schema/TodoDescriptor';
import { GetTasksRequestFilter } from 'owa-todo-service';

export function getFilterForDescriptor(descriptor: TodoDescriptor): GetTasksRequestFilter {
    const { isComplete } = descriptor;
    if (isComplete === false) {
        return {
            taskStatusFilters: [
                {
                    status: 'Completed',
                    equalityOperator: 'ne',
                },
            ],
        };
    } else if (isComplete === true) {
        return {
            taskStatusFilters: [
                {
                    status: 'Completed',
                    equalityOperator: 'eq',
                },
            ],
        };
    } else {
        return { taskStatusFilters: [] };
    }
}
